<template>
    <div class="Power_execl">
        <!-- <me-collapes @collapesCb="collapesCb" :treeTitle="'采集点选择'"> -->
        <div class="tree-wrap">
            <me-tree
                ref="myTree"
                :treeData="data"
                :treeLoading="treeLoading"
                :treeToolBar="false"
                :defaultProps="defaultProps"
                :nodeKey="'point_id'"
                :showCheckbox="true"
                :title="'采集点选择'"
                :cascadingVar="true"
                :checkStrictly.sync="checkStrictly"
                :isCheckClick="true"
                :defaultCheckKeys="defaultCheckKeys"
                :defaultExpandedKeys="defaultCheckKeys"
                @handleCheckBoxClick="handleTreeNodeClick"
            ></me-tree>
        </div>
        <!-- </me-collapes> -->

        <div class="content is-alway-shadow leader-tab" :style="{ width: width }">
            <el-tabs v-model="tabVal" type="card" @tab-click="handleTabClick">
                <el-tab-pane label="日报" name="day"></el-tab-pane>
                <el-tab-pane label="月报" name="month"></el-tab-pane>
                <el-tab-pane label="年报" name="year"></el-tab-pane>
            </el-tabs>
            <div class="search_cont">
                <el-form
                    label-width="60px"
                    :inline="true"
                    :model="searchForm"
                    class="form leader-style-form"
                >
                    <el-form-item label="时间">
                        <el-date-picker
                            v-model="time"
                            align="right"
                            type="date"
                            :clearable="false"
                            placeholder="选择日期"
                            value-format="yyyy-MM-dd"
                            :picker-options="pickerOptions"
                            @change="handleTimeChange"
                            v-show="tabVal === 'day'"
                        ></el-date-picker>
                        <el-date-picker
                            v-model="time"
                            type="month"
                            :clearable="false"
                            placeholder="选择月"
                            value-format="yyyy-MM"
                            :picker-options="pickerOptions"
                            @change="handleTimeChange"
                            v-show="tabVal === 'month'"
                        ></el-date-picker>
                        <el-date-picker
                            v-model="time"
                            type="year"
                            placeholder="选择年"
                            format="yyyy"
                            value-format="yyyy"
                            :clearable="false"
                            :picker-options="pickerOptions"
                            @change="handleTimeChange"
                            v-show="tabVal === 'year'"
                        ></el-date-picker>
                        <div class="button-group">
                            <el-button
                                class="leader-common-button"
                                @click="forwardTimeClick"
                                size="medium"
                            >
                                上一{{
                                    tabVal === "day"
                                        ? "日"
                                        : tabVal === "month"
                                            ? "月"
                                            : "年"
                                }}
                            </el-button>
                            <el-button
                                class="leader-common-button"
                                :disabled="nextTimeDisabled"
                                @click="nextTimeClick"
                                size="medium"
                            >
                                下一{{
                                    tabVal === "day"
                                        ? "日"
                                        : tabVal === "month"
                                            ? "月"
                                            : "年"
                                }}
                            </el-button>
                        </div>
                    </el-form-item>

                    <div style="margin-right:10px;">
                        <el-button
                            class="leader-common-button"
                            size="medium"
                            @click="handleSearchReport"
                        >查询</el-button>
                        <!-- <el-button
                            class="leader-common-button"
                            size="medium"
                            @click="handleExportExl"
                            >导出</el-button
                        >-->
                        -->
                    </div>
                </el-form>
            </div>
            <div class="table_cont-wrap">
                <div class="title">
                    <div class="green"></div>
                    {{
                        tabVal === "day"
                            ? "日报(单位:kW·h)"
                            : tabVal === "month"
                                ? "月报(单位:kW·h)"
                                : "年报(单位:kW·h)"
                    }}
                </div>
                <div class="table-wrap">
                    <div class="table-header" style="position: relative;">
                        <!-- <div class="table-header-colum">序号</div> -->
                        <div class="table-header-colum table-name header-fixed">名称</div>
                        <!-- <div style="position: absolute; top:0; left: 200px"> -->
                        <template v-if="tabVal === 'day'">
                            <div
                                class="table-header-colum"
                                v-for="(item, index) in tableData.hours"
                                :key="index"
                            >{{ index < 9 ? "0" + index : index }}时</div>
                        </template>
                        <template v-if="tabVal === 'month'">
                            <div
                                class="table-header-colum"
                                v-for="(item, index) in tableData.days"
                                :key="index"
                            >{{ index + 1 }}日</div>
                        </template>
                        <template v-if="tabVal === 'year'">
                            <div
                                class="table-header-colum"
                                v-for="(item, index) in tableData.months"
                                :key="index"
                            >{{ index + 1 }}月</div>
                        </template>
                        <div class="table-header-colum">合计</div>
                        <!-- </div> -->
                    </div>
                    <template v-if="tableData.list">
                        <div class="table-row" v-for="(item, index) in tableData.list" :key="index">
                            <!-- <div class="table-row-item">{{ index + 1 }}</div> -->
                            <div
                                class="table-row-item table-name header-fixed"
                            >{{ item.point_name }}</div>
                            <template v-if="tabVal === 'day'">
                                <div
                                    class="table-row-item"
                                    v-for="(item, indexList) in tableData.hours"
                                    :key="item"
                                >
                                    {{
                                        tableData.list[index][
                                            "is_" + (indexList + 1)
                                        ]
                                    }}
                                </div>
                            </template>
                            <template v-if="tabVal === 'month'">
                                <div
                                    class="table-row-item"
                                    v-for="(item, indexMList) in tableData.days"
                                    :key="item"
                                >
                                    {{
                                        tableData.list[index][
                                            "is_" + (indexMList + 1)
                                        ]
                                    }}
                                </div>
                            </template>
                            <template v-if="tabVal === 'year'">
                                <div
                                    class="table-row-item"
                                    v-for="(item,
                                    indexYList) in tableData.months"
                                    :key="item"
                                >
                                    {{
                                        tableData.list[index][
                                            "is_" + (indexYList + 1)
                                        ]
                                    }}
                                </div>
                            </template>
                            <div class="table-row-item">{{ item.total }}</div>
                        </div>
                        <div class="table-row">
                            <!-- <div class="table-row-item"></div> -->
                            <div class="table-row-item table-name header-fixed">合计</div>
                            <template v-if="tabVal === 'day'">
                                <div
                                    class="table-row-item"
                                    v-for="(item, indexList) in tableData.hours"
                                    :key="item"
                                >
                                    {{
                                        tableData["total_" + (indexList + 1)]
                                            | floatFormat
                                    }}
                                </div>
                            </template>
                            <template v-if="tabVal === 'month'">
                                <div
                                    class="table-row-item"
                                    v-for="(item, indexMList) in tableData.days"
                                    :key="item"
                                >
                                    {{
                                        tableData["total_" + (indexMList + 1)]
                                            | floatFormat
                                    }}
                                </div>
                            </template>
                            <template v-if="tabVal === 'year'">
                                <div
                                    class="table-row-item"
                                    v-for="(item,
                                    indexYList) in tableData.months"
                                    :key="item"
                                >
                                    {{
                                        tableData["total_" + (indexYList + 1)]
                                            | floatFormat
                                    }}
                                </div>
                            </template>
                            <div class="table-row-item">{{ tableData.total_all | floatFormat }}</div>
                        </div>
                    </template>
                    <div v-else class="table-nodata">暂无数据</div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Tree from "@/comon/components/tree.vue";
import Collapes from "@/comon/components/collapse-block.vue";
import moment from "moment";
import * as api from "@/http/api.js";
import {
    getDayDataWater,
    getMonthDataWater,
    getYearDataWater,
    getExcelWater
} from "@/http/energy-report-collection.js";
export default {
    components: {
        "me-tree": Tree,
        "me-collapes": Collapes
    },
    filters: {
        // 2. 局部过滤器
        floatFormat(value) {
            return parseInt(value * 100) / 100;
        }
    },
    data() {
        return {
            tabVal: "day",
            time: "",
            pickerOptions: {
                disabledDate(time) {
                    return time.getTime() > Date.now();
                }
            },
            nextTimeDisabled: false,
            todayY: "",
            todayM: "",
            todayD: "",
            data: [],
            treeLoading: false,
            defaultProps: {
                children: "childList",
                label: "point_name"
            },
            checkStrictly: true,
            defaultCheckKeys: [],
            nodeKey: "point_id",
            tableData: {},
            tableLoading: false,
            systemDate: {},
            width: "calc(100% - 340px)"
        };
    },
    created() {
        this.getSysDate("day");
        this.todayY = this.getTimeValue("year");
        this.todayM = this.getTimeValue("month");
        this.todayD = this.getTimeValue("day");
        this.nextTimeDisabled = true;
    },
    mounted() { },
    methods: {
        /**
         * 获取系统时间
         */
        getSysDate(type) {
            api.getSysDate().then(res => {
                if (res && res.error_code === "0") {
                    this.systemDate = res.bus_json;
                    this.time = res.bus_json.sysdate;
                    this.getUnitPointList();
                }
            });
        },
        /**
         * 格式化tree disabled状态；
         */
        tickMenuIdFilter: () => {
            let resultArr = new Array();
            let firstPoint = new Object();
            let getTickMenuId = function (obj) {
                if (
                    undefined === obj ||
                    null === obj ||
                    !(obj instanceof Object)
                ) {
                    return;
                }
                if (obj.t_Q != "1") {
                    //实采集点
                    obj.disabled = true;
                    resultArr.push(obj.id);
                } else {
                    obj.disabled = false;
                    //虚点
                    if (!firstPoint.point_id) {
                        firstPoint = obj;
                    }
                }

                if (null != obj.childList && obj.childList instanceof Array) {
                    for (let child of obj.childList) {
                        getTickMenuId(child);
                    }
                }
            };

            return {
                filter: function (arr) {
                    if (!(arr instanceof Array)) {
                        return false;
                    }
                    resultArr = new Array();
                    firstPoint = new Object();
                    for (let rootMenu of arr) {
                        getTickMenuId(rootMenu);
                    }
                    return { tree: resultArr, firstPoint: firstPoint };
                }
            };
        },
        handleTreeNodeClick(select) {
            this.defaultCheckKeys = this.$refs.myTree.$refs.tree.getCheckedKeys();
            // this.defaultExpandedKeys = [select.point_id];
        },
        /**
         * 获取采集点信息
         */
        getUnitPointList() {
            this.treeLoading = true;
            api.getUnitPointList({ point_class_id: "002" }).then(res => {
                if (res && res.error_code === "0") {
                    this.data = res.bus_json;
                    let formatData = this.tickMenuIdFilter().filter(
                        res.bus_json
                    );
                    this.defaultCheckKeys = formatData.firstPoint.point_id ? [formatData.firstPoint.point_id] : [];
                    this.getDayData();
                }
                this.treeLoading = false;
            });
        },
        /**
         * 日期改变回调函数
         */
        handleTimeChange(val) {
            let toDay = new Date(this.toDay).getTime();
            let selectTime = new Date(val).getTime();
            if (selectTime >= toDay) {
                this.nextTimeDisabled = true;
            } else {
                this.nextTimeDisabled = false;
            }
        },
        /**
         * 日月年tab切换回调事件
         */
        handleTabClick(tab, event) {
            this.nextTimeDisabled = true;
            if (tab.name === "day") {
                this.time = this.systemDate.sysdate;
                this.getDayData();
            } else if (tab.name === "month") {
                this.time = this.systemDate.sysdate3;
                this.getMonthData();
            } else {
                this.time = this.systemDate.sysdate4;
                this.getYearData();
            }
        },
        /**
         * 获取时间值
         * params{type<string>} type = day(日) type = month(月) type = year(年)
         */
        getTimeValue(type) {
            let date = new Date();
            if (type === "year") {
                return date.getFullYear() + "";
            } else if (type === "month") {
                return date.getFullYear() + "-" + (date.getMonth() + 1);
            } else {
                return (
                    date.getFullYear() +
                    "-" +
                    (date.getMonth() + 1) +
                    "-" +
                    date.getDate()
                );
            }
        },
        /**
         * 下一日、下一月、下一年点击
         */

        nextTimeClick() {
            let todayD = new Date(this.todayD).getTime();
            let todayM = new Date(this.todayM).getTime();
            let todayY = new Date(this.todayY).getTime();
            if (this.tabVal === "day") {
                this.time = moment(new Date(this.time))
                    .add(1, "days")
                    .format("YYYY-MM-DD");
            } else if (this.tabVal === "month") {
                this.time = moment(new Date(this.time))
                    .add(1, "months")
                    .format("YYYY-MM");
            } else {
                this.time = moment(new Date(this.time))
                    .add(1, "years")
                    .format("YYYY");
            }
            // 获取报告列表
            this.handleSearchReport();
            let selectTime = new Date(this.time).getTime();
            if (
                (this.tabVal === "day" && selectTime >= todayD) ||
                (this.tabVal === "month" && selectTime >= todayM) ||
                (this.tabVal === "year" && selectTime >= todayY)
            ) {
                this.nextTimeDisabled = true;
            } else {
                this.nextTimeDisabled = false;
            }
        },
        /**
         * 上一日、上一月、上一年点击
         */
        forwardTimeClick() {
            this.nextTimeDisabled = false;
            if (this.tabVal === "day") {
                this.time = moment(new Date(this.time))
                    .subtract(1, "days")
                    .format("YYYY-MM-DD");
            } else if (this.tabVal === "month") {
                this.time = moment(new Date(this.time))
                    .subtract(1, "months")
                    .format("YYYY-MM");
            } else {
                this.time = moment(new Date(this.time))
                    .subtract(1, "years")
                    .format("YYYY");
            }
            // 获取报告列表
            this.handleSearchReport();
        },
        /**
         * 获取日报列表
         */
        getDayData() {
            let params = {};
            if (!this.defaultCheckKeys.length) {
                this.$message({
                    message: "请选择节点后进行查询操作！",
                    type: "warning"
                });
                return;
            }

            let point_ids = this.defaultCheckKeys.join(",");
            params = {
                point_ids: point_ids,
                show_day: this.time
            };
            this.tableLoading = true;
            getDayDataWater(params).then(res => {
                if (res && res.error_code === "0") {
                    this.tableData = res.bus_json;
                }
                this.tableLoading = false;
            });
        },
        /**
         * 获取月报列表
         */
        getMonthData() {
            let params = {};
            if (!this.defaultCheckKeys.length) {
                this.$message({
                    message: "请选择节点后进行查询操作！",
                    type: "warning"
                });
                return;
            }
            let point_ids = this.defaultCheckKeys.join(",");
            this.tableLoading = true;
            params = {
                point_ids: point_ids,
                show_month: this.time
            };
            getMonthDataWater(params).then(res => {
                if (res && res.error_code === "0") {
                    this.tableData = res.bus_json;
                }
                this.tableLoading = false;
            });
        },
        /**
         * 获取年报列表
         */
        getYearData() {
            let params = {};
            if (!this.defaultCheckKeys.length) {
                this.$message({
                    message: "请选择节点后进行查询操作！",
                    type: "warning"
                });
                return;
            }
            let point_ids = this.defaultCheckKeys.join(",");
            this.tableLoading = true;
            params = {
                point_ids: point_ids,
                show_year: this.time
            };
            getYearDataWater(params).then(res => {
                if (res && res.error_code === "0") {
                    this.tableData = res.bus_json;
                }
                this.tableLoading = false;
            });
        },
        /**
         * 选择搜索
         */
        handleSearchReport() {
            if (this.tabVal === "day") {
                this.getDayData();
            } else if (this.tabVal === "month") {
                this.getMonthData();
            } else {
                this.getYearData();
            }
        },
        /**
         * 导出excel表格
         */
        handleExportExl() {
            // const loading = this.$loading({
            //     lock: true,
            //     text: "下载中",
            //     spinner: "el-icon-loading",
            //     background: "rgba(0, 0, 0, 0.7)"
            // });
            let point_ids = this.defaultCheckKeys.join(",") + ",";
            let show_type =
                this.tabVal === "day"
                    ? "1"
                    : this.tabVal === "month"
                        ? "2"
                        : "3";
            getExcelWater({
                show_time: this.time,
                point_ids: point_ids,
                show_type: show_type
            }).then(res => {
                if (res) {
                    const content = res;
                    const blob = new Blob([content]);
                    const fileName =
                        this.tabVal === "day"
                            ? this.time + "日报" + ".xlsx"
                            : this.tabVal === "month"
                                ? this.time + "月报" + ".xlsx"
                                : this.time + "年报" + ".xlsx";
                    if (window.navigator.msSaveOrOpenBlob) {
                        navigator.msSaveBlob(blob, fileName);
                    } else {
                        let link = document.createElement("a");
                        link.href = window.URL.createObjectURL(blob);
                        link.download = fileName;
                        document.body.appendChild(link);
                        let evt = document.createEvent("MouseEvents");
                        evt.initEvent("click", false, false);
                        link.dispatchEvent(evt);
                        document.body.removeChild(link);
                    }
                    this.$message({
                        message: "下载成功！",
                        type: "success"
                    });
                }
                // loading.close();
            });
        },
        /**
         * 监听树结构收起展开
         */
        collapesCb(collapes) {
            this.width = collapes ? "calc(100% - 340px)" : "calc(100% - 56px)";
        }
    }
};
</script>
<style lang="scss">
.Power_execl {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: row;
    .tree-wrap {
        margin: 0 20px;
        width: px2Rem(280px);
        height: 100%;
        overflow: hidden;
        box-sizing: border-box;
        border-radius: px2Rem(5px);
    }
    .content {
        height: calc(98% - 5px);
        margin-top: 5px;
        box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
        border-radius: px2Rem(5px);
        box-sizing: border-box;
        transition: width 500ms;
        .el-tabs--card {
            margin: 0;
        }
        .search_cont {
            width: 100%;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            .form {
                width: 100%;
                display: flex;
                justify-content: space-between;
                .button-group {
                    display: inline-block;
                    margin-left: px2Rem(20px);
                    // button {
                    //     background: rgb(41, 184, 94);
                    //     color: white;
                    //     outline: none;
                    //     border-color: rgb(41, 184, 94);
                    // }
                    .el-button.is-disabled,
                    .el-button.is-disabled:focus,
                    .el-button.is-disabled:hover {
                        border-color: #ebeef5;
                    }
                }
                .el-input__inner {
                    height: px2Rem(36px);
                    line-height: px2Rem(36px);
                }
            }
        }
        .table_cont-wrap {
            width: 100%;
            // padding: 0 10px;
            box-sizing: border-box;
            overflow: hidden;
            .title {
                color: #fff;
                border-bottom: 1px solid #56fcff;
            }
            .green {
                height: px2Rem(12px);
                width: px2Rem(5px);
                background: #56fcff;
                margin: px2Rem(10px);
                float: left;
            }
            width: 100%;
            font-size: px2Rem(16px);
            text-align: left;
            line-height: px2Rem(32px);
        }
        .table-wrap {
            min-width: 100%;
            overflow: auto;
            font-size: px2Rem(14px);
            color: #fff;
            background: none;
            padding-left: 0 !important;
            padding-right: 0 !important;
            .header-fixed {
                position: fixed;
                background-color: #10344a !important;
            }
            .table-header {
            }
            .table-header-colum {
                background: #10344a !important;
            }
            .table-header-colum:nth-child(2) {
                margin-left: px2Rem(200px);
            }
            .table-row {
                .table-row-item:nth-child(2) {
                    margin-left: px2Rem(200px);
                }
            }
            .table-nodata {
                border: 1px solid #ebeef5;
                color: #fff;
            }
            .table-header {
                min-width: 100%;
                display: flex;
                flex-direction: row;
            }
            .table-name {
                width: px2Rem(200px) !important;
                box-sizing: border-box;
            }
            .table-header-colum {
                flex: 1;
                text-align: center;
                min-width: px2Rem(80px);
                padding: 3px 0;
            }
            .table-row:nth-child(2n) {
                color: #ffffff;
                .table-row-item {
                    background: transparent !important;
                }

                .table-name {
                    background: #000 !important;
                }
            }

            .table-row:nth-child(2n + 1) {
                color: #ffffff;
                .table-row-item {
                    background: #10344a !important;
                }
            }
            .table-row {
                display: flex;
                flex-direction: row;
                min-width: 100%;
                .table-row-item {
                    flex: 1;
                    text-align: center;
                    min-width: px2Rem(80px);
                    padding: 3.5px 0;
                }
            }
            .table-nodata {
                text-align: center;
            }
        }
    }
}
</style>
